import { render, staticRenderFns } from "./DevLogins.vue?vue&type=template&id=31e2078e&scoped=true&"
import script from "./DevLogins.vue?vue&type=script&lang=js&"
export * from "./DevLogins.vue?vue&type=script&lang=js&"
import style0 from "./DevLogins.vue?vue&type=style&index=0&id=31e2078e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e2078e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VContainer,VSelect})
